import Vue from 'vue'
import VueI18n from 'vue-i18n'
import es from './es'
import en from './en'
import fr from './fr'
import de from './de'
import it from './it'
import ca from './ca'

Vue.use(VueI18n)

const messages = {
  'es': es,
  'en': en,
  'fr': fr,
  'de': de,
  'it': it,
  'ca': ca
}

const i18n = new VueI18n({
  locale: 'es', // set locale
  fallbackLocale: 'en', // set fallback locale
  messages // set locale messages
})

export default i18n
